module.exports = __webpack_public_path__ + "r-v3/img/facebook.b5318b1a.png";